<template>
	<div class="container">
		<div class="content">
			<div class="card">
				<h3 class="title mb_16">{{ $t('rtr_activity.title') }}</h3>
				<div class="mb_8">
					<div class="d_flex mb_8">
						<div class="info mr_10">
							<date-picker
								is-required
								v-model="startDate"
								:model-config="{ type: 'string' }"
								:locale="$store.state.common.locale"
							>
								<template v-slot="{ inputValue, inputEvents }">
									<label class="calendar_area">
										<input
											class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
											:value="inputValue"
											v-on="inputEvents"
										/>
									</label>
								</template>
							</date-picker>
						</div>
						<div class="info">
							<date-picker
								is-required
								v-model="endDate"
								:model-config="{ type: 'string' }"
								:locale="$store.state.common.locale"
							>
								<template v-slot="{ inputValue, inputEvents }">
									<label class="calendar_area">
										<input
											class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
											id="calendar_area"
											:value="inputValue"
											v-on="inputEvents"
										/>
									</label>
								</template>
							</date-picker>
						</div>
					</div>
					<div class="select_area mb_16">
						<select
							v-model="accountSeq"
							class="asset_area"
							@change="loadListHandler('pageInit')"
						>
							<option :value="null">
								{{ $t('input.placeholder.all_assets') }}
							</option>
							<option
								v-for="item in accounts"
								:key="item.seq"
								:value="item.seq"
							>
								{{ item.asset_title }}
							</option>
						</select>
						<span class="select_icon"></span>
					</div>
					<ul class="tab_area mb_8">
						<li
							:class="[{ selected: selectedTab === 'account' }, 'all']"
							@click="selectedTab = 'account'"
						>
							<a>{{ $t('rtr_wallet_account-assets.account') }}</a>
						</li>
						<li
							:class="[{ selected: selectedTab === 'address' }, 'all']"
							@click="selectedTab = 'address'"
						>
							<a>{{ $t('rtr_wallet_account-assets.address') }}</a>
						</li>
					</ul>
					<div class="select_area" v-if="selectedTab === 'address'">
						<select v-model="addressType" class="asset_area">
							<option value="deposit">{{ $t('rtr_activity.deposit') }}</option>
							<option value="withdraw">
								{{ $t('rtr_activity.withdrawal') }}
							</option>
						</select>
						<span class="select_icon"></span>
					</div>
				</div>
				<div v-if="transferList.length === 0" class="list_none">
					<span class="ERRORGRAY"></span>
					<p>{{ $t('rtr_activity.empty') }}</p>
				</div>
				<div v-if="selectedTab === 'account'" class="list">
					<!-- li 부터 한뭉탱이 -->
					<ul>
						<li v-for="item in transferList" :key="item.seq">
							<div
								v-if="
									item.from_user_name ===
									$store.state.auth.member_info.user_name
								"
							>
								<div class="list_item_box">
									<div class="list_item d_flex justify_between mb_4">
										<p class="list_item fs_14">
											{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
										</p>
										<div class="send_receive">
											<p class="send">{{ $t('rtr_activity.withdrawal') }}</p>
										</div>
									</div>
									<div class="list_item mb_4">
										<p>{{ $t('rtr_activity.recipient') }}</p>
										<p>{{ item.to_user_name }}</p>
									</div>
									<div class="list_item mb_8">
										<p>{{ $t('rtr_activity.text8') }}</p>
										<div class="asset_box">
											<span :class="[item.asset_code, 'small']"></span>
											<p class="code mr_4">
												{{ item.asset_code }}
											</p>
											<p class="name">
												{{ item.asset_title }}
											</p>
										</div>
									</div>
									<div class="list_item">
										<p>{{ $t('rtr_activity.text3') }}</p>
										<div class="num_unit type01">
											<p class="num">{{ item.amount }}</p>
											<p class="unit">{{ item.asset_code }}</p>
										</div>
									</div>
								</div>
								<Accordion>
									<AccordionItem2>
										<template v-slot:accordion-trigger>
											<span class="accordion_trigger_icon"></span>
										</template>
										<template v-slot:accordion-content>
											<div class="accordion_border body_l">
												<div class="list_item">
													<p>{{ $t('rtr_activity.text4') }}</p>
													<p>{{ item.to_account_number }}</p>
												</div>
											</div>
										</template>
									</AccordionItem2>
								</Accordion>
							</div>
							<div v-else>
								<div class="list_item_box">
									<div
										class="list_item d_flex align_items_end justify_between mb_4"
									>
										<p class="list_item fs_14 fc_gray2">
											{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
										</p>
										<div class="send_receive">
											<p class="receive">{{ $t('rtr_activity.deposit') }}</p>
										</div>
									</div>
									<div class="list_item mb_4">
										<p>{{ $t('rtr_activity.sender') }}</p>
										<p>{{ item.from_user_name }}</p>
									</div>
									<div class="list_item mb_8">
										<p>{{ $t('rtr_activity.text5') }}</p>
										<div class="asset_box">
											<span :class="[item.asset_code, 'small']"></span>
											<p class="code mr_4">
												{{ item.asset_code }}
											</p>
											<p class="name">
												{{ item.asset_title }}
											</p>
										</div>
									</div>
									<div class="list_item">
										<p>{{ $t('rtr_activity.text6') }}</p>
										<div class="num_unit type01">
											<p class="num">{{ item.amount }}</p>
											<p class="unit">{{ item.asset_code }}</p>
										</div>
									</div>
								</div>
								<Accordion>
									<AccordionItem2>
										<template v-slot:accordion-trigger>
											<span class="accordion_trigger_icon"></span>
										</template>
										<template v-slot:accordion-content>
											<div class="accordion_border body_l">
												<div class="list_item">
													<p>{{ $t('rtr_activity.text7') }}</p>
													<p>{{ item.from_account_number }}</p>
												</div>
											</div>
										</template>
									</AccordionItem2>
								</Accordion>
							</div>
						</li>
					</ul>
				</div>

				<div v-if="selectedTab === 'address'" class="list">
					<!-- li 부터 한뭉탱이 -->
					<div v-if="addressType === 'deposit'">
						<ul>
							<li v-for="item in transferList" :key="item.seq">
								<div class="list_item_box">
									<div class="list_item d_flex justify_between mb_4">
										<p class="list_item fs_14 fc_gray2">
											{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
										</p>
										<div class="send_receive">
											<p class="receive">{{ $t('rtr_activity.deposit') }}</p>
										</div>
									</div>
									<div class="list_item mb_8">
										<p>{{ $t('rtr_activity.text5') }}</p>
										<div class="asset_box">
											<span :class="[item.asset_code, 'small']"></span>
											<p class="code mr_4">
												{{ item.asset_code }}
											</p>
											<p class="name">
												{{ item.asset_title }}
											</p>
										</div>
									</div>
									<div class="list_item">
										<p>{{ $t('rtr_activity.text6') }}</p>
										<div class="num_unit type01">
											<p class="num">{{ item.request_amount }}</p>
											<p class="unit">{{ item.asset_code }}</p>
										</div>
									</div>
								</div>
								<Accordion>
									<AccordionItem2>
										<template v-slot:accordion-trigger>
											<span class="accordion_trigger_icon"></span>
										</template>
										<template v-slot:accordion-content>
											<div class="accordion_border body_l">
												<div class="list_item">
													<p>{{ $t('rtr_activity.account_number') }}</p>
													<p class="wallet_address">
														{{ item.account_number }}
													</p>
												</div>
											</div>
										</template>
									</AccordionItem2>
								</Accordion>
							</li>
						</ul>
					</div>
					<div v-if="addressType === 'withdraw'">
						<ul>
							<li v-for="item in transferList" :key="item.seq">
								<div class="list_item_box">
									<div class="list_item d_flex justify_between mb_4">
										<p class="list_item fs_14 fc_gray2">
											{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
										</p>
										<div class="send_receive">
											<p class="send">{{ $t('rtr_activity.withdrawal') }}</p>
										</div>
									</div>
									<div class="list_item mb_8">
										<p>{{ $t('rtr_activity.text8') }}</p>
										<div class="asset_box">
											<span :class="[item.asset_code, 'small']"></span>
											<p class="code mr_4">
												{{ item.asset_code }}
											</p>
											<p class="name">
												{{ item.asset_title }}
											</p>
										</div>
									</div>
									<div class="list_item">
										<p>{{ $t('rtr_activity.text3') }}</p>
										<div class="num_unit type01">
											<p class="num">{{ item.request_amount }}</p>
											<p class="unit">{{ item.asset_code }}</p>
										</div>
									</div>
								</div>
								<Accordion>
									<AccordionItem2>
										<template v-slot:accordion-trigger>
											<span class="accordion_trigger_icon"></span>
										</template>
										<template v-slot:accordion-content>
											<div class="accordion_border body_l">
												<div class="list_item">
													<p>{{ $t('rtr_activity.account_number') }}</p>
													<p class="wallet_address">
														{{ item.account_number }}
													</p>
												</div>
											</div>
										</template>
									</AccordionItem2>
								</Accordion>
							</li>
						</ul>
					</div>
				</div>

				<pagination
					v-if="transferList.length !== 0"
					:totalCount="pageNavigation.total_count"
					:totalPage="pageNavigation.total_page"
					:curPage="pageNavigation.cur_page"
					:point="pageNavigation.point"
					:firstPage="pageNavigation.first_page"
					:lastPage="pageNavigation.last_page"
					@change="pageChangeHandler"
				></pagination>
			</div>
		</div>
	</div>
</template>

<script>
import {
	// fetchAccountBalanceLogList,
	fetchAccountTransferList,
} from '@/api/account';
import { commonError } from '@/common/dialog';
import { mapGetters } from 'vuex';
import pagination from '@/components/Pagination';
import Accordion from '@/components/Layout/Accordion.vue';
import AccordionItem2 from '@/components/Layout/AccordionItem2';
import { fetchWithdrawList } from '@/api/withdraw';
import { fetchDepositList } from '@/api/deposit';
import '@/assets/css/activity.m.css';

export default {
	name: 'Activity.m',
	components: { pagination, Accordion, AccordionItem2 },
	data() {
		return {
			isAllChecked: false,
			transferList: [],
			startDate: this.$dayjs(new Date()).add(-6, 'month').toDate(),
			endDate: new Date(),
			accountSeq: null,
			addressType: 'deposit',
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
			selectedTab: 'account',
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
	},
	created() {
		this.accountSeq = this.$route.query.account_seq || null;
		this.init();
	},
	watch: {
		startDate() {
			this.loadListHandler('pageInit');
		},
		endDate() {
			this.loadListHandler('pageInit');
		},
		selectedTab() {
			this.addressType = 'deposit';
			this.loadListHandler('pageInit');
		},
		addressType() {
			this.loadListHandler('pageInit');
		},
	},
	methods: {
		init() {
			this.loadListHandler();
		},
		loadListHandler(type) {
			if (type === 'pageInit') this.curPage = 1;
			if (this.selectedTab === 'account') {
				this.loadTransferList();
			} else if (this.selectedTab === 'address') {
				if (this.addressType === 'deposit') {
					this.loadDepositList();
				} else {
					this.loadWithdrawList();
				}
			}
		},
		async loadTransferList() {
			const params = {
				account_seq: this.accountSeq,
				regdate_start: this.$dayjs(new Date(this.startDate))
					.startOf('day')
					.valueOf(),
				regdate_end: this.$dayjs(this.endDate).endOf('day').valueOf(),
				page: this.curPage,
				list_count: this.listCount,
			};

			const { data, page_navigation } = await fetchAccountTransferList(
				params,
			).catch(commonError);

			this.transferList = data;
			this.pageNavigation = page_navigation;
		},
		async loadDepositList() {
			const params = {
				account_seq: this.accountSeq,
				regdate_start: this.$dayjs(new Date(this.startDate))
					.startOf('day')
					.valueOf(),
				regdate_end: this.$dayjs(this.endDate).endOf('day').valueOf(),
				page: this.curPage,
				list_count: this.listCount,
			};

			const { data, page_navigation } = await fetchDepositList(params).catch(
				commonError,
			);

			this.transferList = data;
			this.pageNavigation = page_navigation;
		},

		async loadWithdrawList() {
			const params = {
				account_seq: this.accountSeq,
				regdate_start: this.$dayjs(new Date(this.startDate))
					.startOf('day')
					.valueOf(),
				regdate_end: this.$dayjs(this.endDate).endOf('day').valueOf(),
				page: this.curPage,
				list_count: this.listCount,
			};

			const { data, page_navigation } = await fetchWithdrawList(params).catch(
				commonError,
			);

			this.transferList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadListHandler();
		},
	},
};
</script>
